import { censusReportPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { ICensusBatchRetrieveParams } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

export const getCensusBatchRetrieve = async (params: ICensusBatchRetrieveParams) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    params.facility_uuid = getFacilityUuid;
  }

  params.enterprise_name = realm;

  const url = `${baseAutomationUrl}${censusReportPath.RETRIEVE}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
    params: { ...params, batch_type: 'CENSUS' },
  });
};
